import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";
import { Form, Select, Input, SubmitButton, ResetButton, DatePicker } from "formik-antd";
import { Formik } from "formik";

import { BasicForm } from "../../../../core/components/form";

import { Button, Divider } from "antd";
import { InputDate } from "../../../../core/components/form";

import { DownloadOutlined } from "@ant-design/icons";

const LoginSchema = Yup.object().shape({
    date: Yup.date().required("Cannot be blank").typeError("Must be a date"),
    code: Yup.string().required("Cannot be blank"),
});

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

/**
 *
 */
const Formulario = (props) => {
    const { alta, loaded, data } = props;

    const _goBack = () => {
        props.history.goBack();
    };

    const _initialForm = () => {
        return {
            code: "",
            date: "",
        };
    };

    return (
        <Formik initialValues={_initialForm()} validationSchema={LoginSchema} onSubmit={props.handleSubmit}>
            {({ values, submitForm, setFieldValue, errors, touched, setFieldTouched, isValid, isSubmitting }) => (
                <Form abelCol={{ xs: 4 }} rapperCol={{ xs: 16 }} layout="inline">
                    <Form.Item label="Code" name="code" hasFeedback={true} showValidateSuccess={true}>
                        <Input name="code" placeholder="Code" />
                    </Form.Item>

                    <Form.Item label="Finance Date" name="date" hasFeedback={true} showValidateSuccess={true}>
                        <DatePicker name="date" format="YYYY-MM-DD" howTime={true} placeholder="Finance Date" />
                    </Form.Item>
                    <Button.Group>
                        <SubmitButton type="primary">Generate</SubmitButton>
                        <ResetButton type="default">Clear</ResetButton>
                    </Button.Group>
                </Form>
            )}
        </Formik>
    );
};

export default Formulario;
